import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import moment from "moment";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 30,
    backgroundColor: "#fff",
  },
  title: {
    fontSize: 22,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 20,
    color: "#333",
  },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#ddd",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#ddd",
    alignItems: "center",
  },
  tableHeaderCell: {
    padding: 10,
    fontSize: 12,
    fontWeight: "bold",
    backgroundColor: "#f2f2f2",
    borderRightWidth: 1,
    borderRightColor: "#ddd",
    textAlign: "center",
    flex: 1,
  },
  tableCell: {
    padding: 10,
    fontSize: 12,
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#ddd",
    flex: 1,
  },
  lastColumn: {
    borderRightWidth: 0, // Remove border for the last column
  },
});

const SkypointBillingInvoicePDF = ({ billingData }) => {
  if (!billingData || billingData.length === 0) {
    return <Text>No data available</Text>;
  }

  return (
    <Document>
      <Page style={styles.page}>
        <Text style={styles.title}>
          {billingData?.some((item) => item.recurring)
            ? "Billing Recurring Invoice Report"
            : "Billing Invoice Report"}
        </Text>
        <View style={styles.table}>
          {/* Table Header */}
          <View style={styles.tableRow}>
            <Text style={styles.tableHeaderCell}>Invoice Number</Text>
            <Text style={styles.tableHeaderCell}>Invoice Title</Text>
            <Text style={styles.tableHeaderCell}>Total Amount</Text>
            <Text style={styles.tableHeaderCell}>Due Date</Text>
            <Text style={[styles.tableHeaderCell, styles.lastColumn]}>
              Status
            </Text>

            {/* Conditionally add Recurring columns */}
            {billingData.some((item) => item.recurring) && (
              <>
                <Text style={styles.tableHeaderCell}>Recurring Date</Text>
                <Text style={styles.tableHeaderCell}>Frequency</Text>
              </>
            )}
          </View>

          {billingData?.map((item, index) => (
            <View key={index} style={styles.tableRow}>
              <Text style={styles.tableCell}>{item.invoiceNumber || "NA"}</Text>
              <Text style={styles.tableCell}>{item.invoiceTitle || "NA"}</Text>
              <Text style={styles.tableCell}>
                {item.totalAmount || "NA"} USD
              </Text>

              <Text style={styles.tableCell}>
                {item.invoiceDueDate
                  ? moment(item.invoiceDueDate).format("MMMM Do YYYY")
                  : "NA"}
              </Text>

              <Text style={styles.tableCell}>{item.status || "NA"}</Text>

              {/* Conditionally add Recurring columns */}
              {item.recurring && (
                <>
                  <Text style={styles.tableCell}>
                    {item.recurringDate
                      ? moment(item.recurringDate).format("MMMM Do YYYY")
                      : "NA"}
                  </Text>
                  <Text style={styles.tableCell}>{item.Frequency || "NA"}</Text>
                </>
              )}
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default SkypointBillingInvoicePDF;
